import { Logger } from '@zmedia/bm-soccer-ui/utils';
import React, { memo, useEffect } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { Content500 } from '../500';

export function ErrorFallback({ error }: FallbackProps) {
    useEffect(() => {
        Logger.error(
            500,
            '|ErrorFallback | ',
            error?.message,
            error?.stack,
            error?.name
        );
    }, []);

    return <Content500 />;
}

export default memo(ErrorBoundary) as any;
